import { render, staticRenderFns } from "./detalle.vue?vue&type=template&id=5766d1d1&scoped=true"
import script from "./detalle.vue?vue&type=script&lang=js"
export * from "./detalle.vue?vue&type=script&lang=js"
import style0 from "./detalle.vue?vue&type=style&index=0&id=5766d1d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5766d1d1",
  null
  
)

export default component.exports